module.exports = __webpack_public_path__ + "img/rir-logo-dark-collapsed.8f923907.svg";